import {
  AppBar,
  Container,
  Grid,
  Typography,
  Button,
} from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import React from "react";
import {
  createUser,
  signInWithFacebook,
  signInWithGoogle,
} from "../utils/Auth";
import imgBanner from "../assets/3793099.jpg";
import { ReactComponent as GoogleIcon } from "../assets/Google__G__Logo.svg";
import Branding from "./Branding";
import Footer from "./Footer";


function LandingPage() {
  // const [checked, setChecked] = React.useState(false);

  // const handleGoogleSignin = async () => {
  //   await signInWithGoogle();
  // };

  // const handleFacebookSignin = async () => {
  //   await signInWithFacebook();
  //   // console.log(user.displayName);
  // };

  const handleGoogleSignup = async () => {
    const user = await signInWithGoogle()
    await createUser(user)
  }
  const handleFacebookSignup = async () => {
    const user = await signInWithFacebook()
    await createUser(user)
  }

  return (
    <Grid
      style={{
        backgroundImage: `url(${imgBanner})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center center",
      }}
      container
      spacing={2}
    >
      <AppBar position="static">
        <Branding />
      </AppBar>
      <Container style={{marginTop: "70px"}}>
        <Grid item xs={12}>
          <Typography variant="h2">A new chat app.</Typography>
        </Grid>
        <Typography variant="subtitle1">
          login to your account, or create a new account
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Button
              style={{ backgroundColor: "white" }}
              onClick={handleGoogleSignup}
              variant="outlined"
              size="large"
              startIcon={<GoogleIcon />}
            >
              Signin with Google
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
            disabled={true}
              onClick={handleFacebookSignup}
              variant="outlined"
              size="large"
              style={{ backgroundColor: "#1877F2", color: "white" }}
              startIcon={<FontAwesomeIcon icon={faFacebook} />}
            >
              Signin with Facebook
            </Button>
          </Grid>
        </Grid>
        
      </Container>
     <Footer />
    </Grid>
  );
}

export default LandingPage;
